module.exports = __webpack_public_path__ + "static/media/kod-paragon.29891d20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/kod-paragon.jpg
// module id = 1101
// module chunks = 0